import React from 'react';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/common/finalSale.scss';

interface Props {
  className?: string;
}
export const FinalSale = ({ className }: Props) => {
  const { testId } = useMartyContext();

  return (
    <em className={cn(css.container, className)} data-test-id={testId('finalSale')}>
      Final Sale - No Returns
    </em>
  );
};

export default FinalSale;
